import DemoListItem from './DemoListItem';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';

const NAMES = ['Aurora Cafe', 'Blue Harbor', 'Cedar Market', 'Delta Bistro', 'Echo Outlet', 'Falcon Store'];
const CITIES = ['Vienna', 'Budapest', 'Prague', 'Warsaw', 'Zagreb'];
const STATUSES = ['Created', 'Confirmed', 'Planned', 'Completed'];

function buildShops(): DemoListItem[] {
  const shops: DemoListItem[] = [];
  for (let i = 1; i <= 30; i++) {
    const shop = new DemoListItem();
    shop.ShopId = 10400 + i;
    shop.ShopName = NAMES[i % NAMES.length] + ' #' + i;
    shop.City = CITIES[i % CITIES.length];
    shop.Status = STATUSES[i % STATUSES.length];
    shop.VisitDate = '2026-0' + ((i % 6) + 1) + '-1' + (i % 9);
    shop.Fee = 25 + (i % 7) * 5;
    shop.IsActive = i % 5 !== 0;
    shops.push(shop);
  }
  return shops;
}

export const DEMO_SHOPS = buildShops();

// Drop-in replacement for a backend list service: filters, sorts and pages the
// in-memory array and resolves with the same envelope the real services return.
export function demoListServiceFunction(
  orderBy: string,
  orderDirection: string,
  pageNumber: number,
  numberOfElements: number,
  searchItem: any
) {
  // TabOfDataTable encodeURIComponent()s every string filter before calling the
  // serviceFunction (real backends decode them) — undo that here so filters with
  // spaces ("Aurora Cafe") still match.
  const decode = (value: any) => (typeof value === 'string' ? decodeURIComponent(value) : value);
  const rows = DEMO_SHOPS.filter((row: any) => {
    if (searchItem) {
      const shopName = decode(searchItem.ShopName);
      const city = decode(searchItem.City);
      const status = decode(searchItem.Status);
      if (shopName && row.ShopName.toLowerCase().indexOf(String(shopName).toLowerCase()) === -1) return false;
      if (city && row.City.toLowerCase().indexOf(String(city).toLowerCase()) === -1) return false;
      if (status && row.Status !== status) return false;
      if (
        searchItem.IsActive !== undefined &&
        searchItem.IsActive !== null &&
        searchItem.IsActive !== '' &&
        String(row.IsActive) !== String(searchItem.IsActive)
      )
        return false;
    }
    return true;
  });
  const sorted = rows.slice().sort((a: any, b: any) => {
    const av = a[orderBy];
    const bv = b[orderBy];
    const cmp = av > bv ? 1 : av < bv ? -1 : 0;
    return orderDirection === OrderDirectionsEnum.Desc ? -cmp : cmp;
  });
  const start = (pageNumber - 1) * numberOfElements;
  return Promise.resolve({
    data: sorted.slice(start, start + numberOfElements),
    pageNumber,
    numberOfElementsInTheTable: sorted.length,
  });
}

export function convertDemoItems(rawItems: any[]) {
  return rawItems.map((raw) => new DemoListItem(raw));
}
